import { createSlice } from '@reduxjs/toolkit';

export const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        notifications: [
            // {
            //     id: '', // moment().unix()
            //     content: '',
            //     type: '', // 'success', 'info', 'warning', 'danger'
            // }
        ],
        tipoMembresia: 'FREE',
        mensajes: {
            citas: "",
            retinografia: "",
            laboratorio: "",
            podologia: "",
            videollamadas: ""
        }
    },
    reducers: {
        addNotification: (state, { payload }) => {
            state.notifications = [
                ...state.notifications,
                {
                    id: payload.id,
                    content: payload.content,
                    type: payload.type,
                }
            ];
        },
        removeNotification: (state, { payload }) => {
            state.notifications = state.notifications.filter(noty => noty.id !== payload);
        },
        clearNotifications: (state) => {
            state.notifications = [];
        },
        setTipoMembresia: (state, { payload }) => {
            state.tipoMembresia = payload;
        },
        clearTipoMembresia: (state, { payload }) => {
            state.tipoMembresia = 'FREE';
        },
        setMensajes: (state, { payload }) => {
            state.mensajes = payload;
        },
        clearMensajes: (state, { payload }) => {
            state.mensajes = {
                citas: "",
                retinografia: "",
                laboratorio: "",
                podologia: "",
                videollamadas: ""
            };
        },
    }
});


// Action creators are generated for each case reducer function
export const { addNotification, removeNotification, clearNotifications, setTipoMembresia, clearTipoMembresia, setMensajes, clearMensajes } = uiSlice.actions;